/* global window */
import I18n from 'lib/i18n'
import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Select from 'lib/forms/select'
import range from 'lib/utils/range'

function leftPad (number, count) {
  return number.toString().padStart(count, '0')
}

function dateStringToState (string) {
  const [year, month, day] = (string || '').split('-')

  return {
    year: parseInt(year || 0),
    month: parseInt(month || 0),
    day: parseInt(day || 0)
  }
}

export default class DateStringSelect extends Component {
  static propTypes = {
    dateString: PropTypes.string,
    onChange: PropTypes.func.isRequired, // (dateString, valid?)
    allowBlank: PropTypes.bool
  }

  constructor (props) {
    super(props)

    this.state = dateStringToState(props.dateString)
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.dateString !== this.props.dateString) {
      this.setState(dateStringToState(nextProps.dateString))
    }
  }

  setTimeState = changes => {
    const nextState = Object.assign({}, this.state, changes)
    const { day, month, year } = nextState

    this.setState(changes)

    if (day === 0 && month === 0 && year === 0) {
      this.props.onChange(null, false)
    } else {
      const valid = day !== 0 && month !== 0 && year !== 0
      const date = leftPad(year, 4) + '-' + leftPad(month, 2) + '-' + leftPad(day, 2)
      this.props.onChange(date, valid)
    }
  }

  updateYear = value => {
    this.setTimeState({ year: parseInt(value || 0) })
  }

  updateMonth = value => {
    this.setTimeState({ month: parseInt(value || 0) })
  }

  updateDay = value => {
    this.setTimeState({ day: parseInt(value || 0) })
  }

  years () {
    return range(1900, new Date().getYear() + 1900)
      .reverse()
      .map(y => ({ id: y, name: y }))
  }

  months () {
    return range(1, 12).map(m => ({ id: m, name: I18n.t('date.month_names')[m] }))
  }

  days () {
    return range(1, 31).map(y => ({ id: y, name: y }))
  }

  render () {
    const { allowBlank } = this.props
    const { day, month, year } = this.state

    return (
      <div>
        <div style={{ display: 'inline-block', verticalAlign: 'top', lineHeight: '29px' }} data-attr='birthday'>
          <Select
            value={day}
            selectClassName='date-day'
            dataAttr='date-day'
            options={this.days()}
            placeholder={allowBlank || day === 0 ? I18n.t('datetime.prompts.day') : null}
            onValueChange={this.updateDay}
          />{' '}
          <Select
            value={month}
            selectClassName='date-month'
            dataAttr='date-month'
            options={this.months()}
            placeholder={allowBlank || month === 0 ? I18n.t('datetime.prompts.month') : null}
            onValueChange={this.updateMonth}
          />{' '}
          <Select
            value={year}
            selectClassName='date-year'
            dataAttr='date-year'
            options={this.years()}
            placeholder={allowBlank || year === 0 ? I18n.t('datetime.prompts.year') : null}
            onValueChange={this.updateYear}
          />
        </div>
      </div>
    )
  }
}
